module.exports = __webpack_public_path__ + "img/banner_title.1315a711.png";